import GoogleSignInButton from "./GoogleSignInButton";
import { PositionTrendChart } from "./PositionTrendChart";
import { AiModeCitationsChart } from "./AiModeCitationsChart";

// Register components for react-rails
window.GoogleSignInButton = GoogleSignInButton;
window.PositionTrendChart = PositionTrendChart;
window.AiModeCitationsChart = AiModeCitationsChart;
